import GiftCardsV2 from './GiftCardsV2';

export default GiftCardsV2;
